import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
// import http from "services/http";
import http from "services/httpClient";

interface Label {
  label: string;
  column_index: number;
  unit?: string;
  is_enabled: boolean;
}

interface WindrosePropertiesModalProps {
  show: boolean;
  onClose: () => void;
  config: any;
  deviceId: number;
  refetchGraphs: () => void;
}

export default function WindrosePropertiesModal({
  show,
  onClose,
  config,
  deviceId,
  refetchGraphs,
}: WindrosePropertiesModalProps) {
  const [labels, setLabels] = useState<Label[]>([]);
  const [selectedSpeedIndex, setSelectedSpeedIndex] = useState<number | "">("");
  const [selectedDirectionIndex, setSelectedDirectionIndex] = useState<number | "">("");

    useEffect(() => {
        // console.log("🧩 config.chart_labels:", config.chart_labels);
        if (!show) return;

        const fetchLabels = async () => {
            const res = await http.get(`/device/${deviceId}/labels`);
            const data = await res.data;
            setLabels(data);
        };

        fetchLabels();
    }, [deviceId, show]);

    // Separate effect to wait for labels before setting selection
    useEffect(() => {
        if (!show || labels.length === 0) return;

        // console.log("🧩 config.chart_labels:", config.chart_labels);
        // console.log("📊 available labels:", labels);

        const chartLabels: number[] = Array.isArray(config.chart_labels)
            ? config.chart_labels.map((l: any) =>
                typeof l === "object" ? l.column_index : l
            )
            : [];

        setSelectedSpeedIndex(chartLabels[0] ?? "");
        setSelectedDirectionIndex(chartLabels[1] ?? "");
    }, [labels, config.chart_labels, show]);

  const handleSave = async () => {
    if (selectedSpeedIndex === "" || selectedDirectionIndex === "") return;

    const updatedConfig = {
      ...config,
      chart_labels: [selectedSpeedIndex, selectedDirectionIndex],
    };
    await http.patch(`/graphs/${config.id}`, {
      graph_config: updatedConfig,
    });

    refetchGraphs();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Windrose Chart Properties</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Wind Speed Label</Form.Label>
          <Form.Select
            value={selectedSpeedIndex}
            onChange={(e) => setSelectedSpeedIndex(Number(e.target.value))}
          >
            <option value="">-- Select Speed Label --</option>
            {labels.map((l) => (
              <option
                key={l.column_index}
                value={l.column_index}
                disabled={!l.is_enabled}
              >
                {l.label} [x{l.column_index}]{!l.is_enabled ? " [Disabled]" : ""}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group>
          <Form.Label>Wind Direction Label</Form.Label>
          <Form.Select
            value={selectedDirectionIndex}
            onChange={(e) => setSelectedDirectionIndex(Number(e.target.value))}
          >
            <option value="">-- Select Direction Label --</option>
            {labels.map((l) => (
              <option
                key={l.column_index}
                value={l.column_index}
                disabled={!l.is_enabled}
              >
                {l.label} [x{l.column_index}]{!l.is_enabled ? " [Disabled]" : ""}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={selectedSpeedIndex === "" || selectedDirectionIndex === ""}
        >
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
